import axios from 'axios';
import { getToken, setToken } from '../../utils/utils';
import { toast } from 'react-toastify';
import { GET_NEW_JWT_TOKEN } from '../apiEndPoint';
import secureLocalStorage from 'react-secure-storage';
import { DISPATCH } from '../../../store';
import { logOutSuccess } from '../../../store/slices/authSlice';

const instance = axios.create({
	baseURL: process.env.REACT_APP_BASE_API_URL // "https://run.mocky.io/v3"
});

instance.interceptors.request.use((req: any) => {
	const token = getToken('login-auth-token');

	// console.log('token', token);

	const auth = token ? `Bearer ${token}` : '';
	req.headers['Authorization'] = auth;
	req.headers['access-control-allow-origin'] = '*';
	req.headers['Content-Type'] = 'application/json; charset=utf-8';
	req.headers['accept-language'] = 'en';

	// console.log(req);

	return req;
});

instance.interceptors.response.use(
	res => {
		try {
			if (res.status === 200 || res.status === 201 || res.status === 204) {
				return res;
			} else if (res.data !== '') {
				toast.error('Somthing went wrong.');
			} else {
				toast.error('Somthing went wrong.');
			}
		} catch (err) {
			toast.error(res.data.data.message);
		}
		return res;
	},
	async error => {
		const originalRequest = error.config;
		if (error.response.status === 401 && !originalRequest._retry) {
			originalRequest._retry = true;
			try {
				const refreshToken = getToken('refreshToken');
				const headers = { 'accept-language': 'en' };
				try {
					const response = await axios.post(
						`${process.env.REACT_APP_BASE_API_URL}${GET_NEW_JWT_TOKEN}`,
						{ refreshToken },
						{ headers }
					);
					const data = response.data.data;
					setToken('refreshToken', data.refreshToken);
					setToken('login-auth-token', data.accessToken);
					// Retry the original request with the new token
					originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
					return axios(originalRequest);
				} catch (error: any) {
					if (error.response && error.response.status === 400) {
						// Perform logout or any other action on token failure
						DISPATCH(logOutSuccess());
					}
					return Promise.reject(error);
				}
			} catch (error) {
				// Handle refresh token error or redirect to login
				return Promise.reject(error);
			}
		}
		return Promise.reject(error);
	}
);

export default instance;
